import React, { useState, useEffect, useRef } from 'react';

import Button from 'react-bootstrap/Button';
import Modal from "react-bootstrap/Modal";
import scoringService from "../../services/ScoringService";
import { CardType } from '../../models/enums/CardType';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UseFullPageLoaderHook from "./Hook/UseFullPageLoaderHook";
import { ScoringInputType } from '../../models/enums/ScoringInputType';
const WatcherCardsMessageModal = (props) => {

    const { show, onHide, onShow, setSelectedPlayer, selectedPlayer, fixtureRoomId, videoTime, setIsCardHighlighted, inputItemList } = props;
    const [errorText, setErrorText] = useState(null);
    const [loader, showLoader, hideLoader] = UseFullPageLoaderHook();
    let errorLabel = errorText && errorText.length > 0 ? (
    <span className="text-danger">{errorText}</span>
    ) : (
    <></>
    );
    
    const handleConfirm = async (cardType) => {
        try {
            showLoader();
            onHide();
            await scoringService.setCardScore(fixtureRoomId, selectedPlayer.teamId, selectedPlayer.position, cardType, videoTime, videoTime, selectedPlayer.shirtNumber);
            setIsCardHighlighted(true); 
            setSelectedPlayer(null);               
            hideLoader();
        }
        catch (err) {
            onShow();
            hideLoader();
        if (err && err.data && err.data.error) {
            setErrorText(err.data.error);
        } else {
            setErrorText("An error occurred");
        }
    }
    }

    return(
        <>
        {inputItemList?.filter(x => x.playerScoreKey === selectedPlayer?.key && x.time <= videoTime && (x.type === ScoringInputType.YellowCard || x.type === ScoringInputType.RedCard)).length > 0 &&
            <div>
            <Modal
                show={show}
                onHide={onHide}
                backdrop="static"
                centered
            >
                <Modal.Header>
                        <Modal.Title>
                            {
                                inputItemList?.filter(x => x.playerScoreKey === selectedPlayer?.key && x.type === ScoringInputType.YellowCard).length === 1 ? (
                                <>
                                    <h3>
                                        Scoring Unavailable - Player Off Pitch - Yellow Carded
                                    </h3>
                                </>
                                ) : inputItemList?.some(x => x.playerScoreKey === selectedPlayer?.key && x.type === ScoringInputType.RedCard) ?
                                (<>
                                    <h3>
                                        Scoring Unavailable - Player Off Pitch - Red Carded
                                    </h3>   
                                </>) :
                                (<>
                                    <h3>
                                        Scoring Unavailable - Second Yellow Carded
                                    </h3>   
                                </>)
                            }
                    </Modal.Title>
                </Modal.Header>
                <Modal.Footer>
                    <Row>
                        <Col>{errorLabel}</Col>
                    </Row>
                            {inputItemList?.filter(x => x.playerScoreKey === selectedPlayer?.key && x.type === ScoringInputType.YellowCard).length === 1 ? (
                                <>
                                    <Button variant="success" onClick={() => {handleConfirm(CardType.YellowCard)}}>End Yellow Card - Return Player To Play ?</Button>
                            </>
                            ) : inputItemList?.some(x => x.playerScoreKey === selectedPlayer?.key && x.type === ScoringInputType.RedCard) ? (
                                <>
                                    <Button variant="success" onClick={() => {handleConfirm(CardType.RedCard)}}>End Red Card - Return Player To Play ?</Button>
                            </>
                            ) :  (<></>)}        
                
                <Button variant="danger" onClick={(e) => {
                        onHide(e);
                        setSelectedPlayer(null);
                        setErrorText(null);
                    }}>Cancel</Button>
                </Modal.Footer>
                    </Modal>;
                    {loader}
                </div>
        }
        </>
    );
}

export default WatcherCardsMessageModal; 